export default __webpack_public_path__ + "static/media/threeWomenAtTheSpring.d640f67f.jpg";